module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetHigh@2x.e21d98e.webp";